module.exports = __webpack_public_path__ + "static/media/vienna-1.a38d4e4f.jpg";